import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[appDragDrop]',
    standalone: true,
})
export class DragDropDirective {
    @Input() isDroppable: boolean = true;

    @Output() onFileDropped = new EventEmitter<any>();

    @HostBinding('style.background-color') background: any;
    @HostBinding('style.opacity') opacity: any;

    private dragEnterCount = 0;

    @HostListener('dragover', ['$event']) onDragOver(evt: any) {
        if (this.isDroppable) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    }

    @HostListener('dragenter', ['$event']) public onDragEnter(evt: any) {
        if (this.isDroppable) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragEnterCount++;
            if (this.dragEnterCount === 1) {
                this.background = '#99ddff';
                this.opacity = 1;
            }
        }
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
        if (this.isDroppable) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragEnterCount--;
            if (this.dragEnterCount === 0) {
                this.background = 'var(--background-upload)';
                this.opacity = '1';
            }
        }
    }

    @HostListener('drop', ['$event']) public ondrop(evt: DragEvent) {
        if (this.isDroppable) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragEnterCount = 0;
            this.background = 'var(--background-upload)';
            this.opacity = '1';
            const items = evt?.dataTransfer?.items;

            this.traverseFiles(items).then(fileEntries => {
                this.onFileDropped.emit(fileEntries);
            });
        }
    }

    async traverseFiles(items: any) {
        let fileEntries: any[] = [];

        let queue: any[] = [];
        for (let i = 0; i < items.length; i++) {
            queue.push(items[i].webkitGetAsEntry());
        }
        while (queue.length > 0) {
            let entry = queue.shift();
            if (entry.isFile) {
                fileEntries.push(await this.convertFileEntryToFile(entry));
            } else if (entry.isDirectory) {
                queue.push(...(await this.readAllDirectoryEntries(entry.createReader())));
            }
        }
        return fileEntries;
    }

    // Get all the entries (files or sub-directories) in a directory
    // by calling readEntries until it returns empty array
    async readAllDirectoryEntries(directoryReader: any) {
        let entries = [];
        let readEntries = await this.readEntriesPromise(directoryReader);
        while (readEntries.length > 0) {
            entries.push(...readEntries);
            readEntries = await this.readEntriesPromise(directoryReader);
        }
        return entries;
    }

    // Wrap readEntries in a promise to make working with readEntries easier
    // readEntries will return only some of the entries in a directory
    // e.g. Chrome returns at most 100 entries at a time
    async readEntriesPromise(directoryReader: any): Promise<any[]> {
        try {
            return await new Promise((resolve, reject) => {
                directoryReader.readEntries(resolve, reject);
            });
        } catch (err) {
            // console.log(err);
            return [];
        }
    }

    async convertFileEntryToFile(fileEntry: any): Promise<any> {
        try {
            return await new Promise((resolve, reject) => {
                fileEntry.file(resolve, reject);
            });
        } catch (err) {
            // console.log(err);
        }
    }
}
